import type { FieldScrollTargetProps } from './FieldScroll.interface';
import {
  FIELD_SCROLL_MARGIN_TOP,
  MOBILE_FIELD_SCROLL_MARGIN_TOP,
} from './FieldScroll.utils';

export { FIELD_ERROR_SCROLL_SELECTOR } from './FieldScroll.utils';

export const FieldScrollTarget = ({
  children,
  hasError,
  isMobile,
  name,
}: FieldScrollTargetProps) => (
  <div
    data-ob-scroll-field={name}
    data-ob-scroll-error={hasError ? 'true' : undefined}
    style={{
      width: '100%',
      scrollMarginTop: isMobile
        ? MOBILE_FIELD_SCROLL_MARGIN_TOP
        : FIELD_SCROLL_MARGIN_TOP,
    }}
  >
    {children}
  </div>
);
